import type { ReactNode } from 'react';

export interface RecoveryLayoutProps {
  readonly title: string;
  readonly children: ReactNode;
  /** When false, surface owns the visible heading (avoids duplicate titles). */
  readonly showTitle?: boolean;
}

/**
 * Full-panel recovery shell — fills the CustomerAppShell main column.
 * Do not re-apply max-w / safe-area here (shell already constrains width).
 */
export function RecoveryLayout({
  title,
  children,
  showTitle = false,
}: RecoveryLayoutProps): JSX.Element {
  return (
    <main
      className="flex w-full min-w-0 flex-1 flex-col justify-center py-6 min-h-[calc(100dvh-5.5rem)]"
      data-testid="recovery-host"
      aria-label={showTitle ? undefined : title}
      aria-labelledby={showTitle ? 'recovery-host-title' : undefined}
    >
      {showTitle ? (
        <h1
          id="recovery-host-title"
          className="mb-4 text-2xl font-semibold tracking-tight text-[var(--color-on-surface)]"
        >
          {title}
        </h1>
      ) : null}
      <div className="flex w-full min-w-0 flex-1 flex-col justify-center">{children}</div>
    </main>
  );
}
